<template>
  <div class="question-parts-preview">
    <div
      v-for="(part, index) in sideParts"
      :key="part.id || `${part.type}-${index}`"
      class="d-flex align-items-center mb-50"
    >
      <span v-if="part.is_hint" class="mr-50" title="Подсказка">💡</span>

      <b-badge v-if="part.missing" variant="light-danger" class="mr-50">нет файла</b-badge>

      <template v-else-if="part.type === 'audio'">
        <b-button
          variant="flat-primary"
          size="sm"
          class="btn-icon rounded-circle mr-50"
          title="Прослушать"
          @click="playAudio(part, index)"
        >
          <feather-icon :icon="isPlaying(part, index) ? 'PauseIcon' : 'PlayIcon'" size="16" />
        </b-button>
        <span class="text-muted small">аудио</span>
      </template>

      <template v-else-if="part.type === 'image'">
        <img
          :src="mediaUrl(part)"
          class="preview-thumb mr-50"
          alt=""
          @click="openImage(mediaUrl(part))"
        >
      </template>

      <template v-else-if="part.type === 'video'">
        <video
          :src="mediaUrl(part)"
          class="preview-thumb mr-50"
          controls
          preload="none"
        />
      </template>

      <template v-else-if="part.placement === 'answer_options'">
        <span class="text-muted small mr-50">Варианты</span>
        <span class="preview-options">{{ part.text }}</span>
      </template>

      <span v-else>{{ part.text }}</span>
    </div>

    <div v-if="!sideParts.length" class="text-muted small">—</div>

    <b-modal
      v-model="imageModal"
      size="lg"
      hide-footer
      centered
      title="Изображение"
    >
      <img :src="imageModalUrl" class="w-100" alt="">
    </b-modal>
  </div>
</template>

<script>
import { BBadge, BButton, BModal } from 'bootstrap-vue'
import { ref, computed, getCurrentInstance } from '@vue/composition-api'
import { toggleTrack, isTrackPlaying } from '@/layouts/components/globalPlayer'

export default {
  components: { BBadge, BButton, BModal },
  props: {
    // [{side, type, text, url|media_url, is_hint, missing}]
    parts: { type: Array, default: () => [] },
    // Какую сторону показывать: question | answer; пусто — все части
    side: { type: String, default: '' },
  },
  setup(props) {
    const instanceUid = getCurrentInstance().proxy._uid
    const imageModal = ref(false)
    const imageModalUrl = ref('')

    const sideParts = computed(() => (props.parts || []).filter(part => !props.side || part.side === props.side))

    // Хранилище отдаёт url, черновик импорта — подписанный media_url
    const mediaUrl = part => part.url || part.media_url || ''

    const playKey = (part, index) => `question-part-${instanceUid}-${part.id || `${props.side}-${index}`}`

    const playAudio = (part, index) => {
      toggleTrack({
        key: playKey(part, index),
        url: mediaUrl(part),
        title: part.text || 'Аудио вопроса',
        artist: '',
        sourceLabel: part.is_hint ? 'Подсказка' : 'Хранилище вопросов',
        link: null,
        details: [],
        hint: null,
      })
    }

    const isPlaying = (part, index) => isTrackPlaying(playKey(part, index))

    const openImage = url => {
      imageModalUrl.value = url
      imageModal.value = true
    }

    return {
      imageModal, imageModalUrl, sideParts, mediaUrl, playAudio, isPlaying, openImage,
    }
  },
}
</script>

<style scoped>
.preview-thumb {
  width: 70px;
  height: 50px;
  object-fit: cover;
  border-radius: 4px;
  cursor: pointer;
}
.preview-options {
  white-space: pre-line;
}
</style>
